export function logErrorBlock(messageBlock: string[] = []): void {
  const header = 'VISAO > An error occurred while using the viewer API:';
  console.error([header, ...messageBlock].join('\n\t\t'));
}
